$(function () {
  var banner_tokens = []

  $("a[href*='banner_stats']").each(function (idx, el) {
    var segments = $(el).attr('href').split('/')
    banner_tokens.push(segments[segments.length - 1])
  })

  if (banner_tokens.length > 0) {
    $.post($('body').data('banner-stats-url'), { tokens: banner_tokens })
  }
})
